import React from 'react';
import './AppMenu.scss';
import AppConfig from '../../config/default';
import { NavLink } from 'react-router-dom';
import languageManager from '../../helpers/Language';
// Ionicon
import {
    HomeOutline,
    CloudOutline,
    PieChartOutline,
    SettingsOutline,
    StatsChart,
    CloudUploadOutline,
    LogoDropbox,
    FolderOutline,
} from 'react-ionicons/lib';
import { connect } from 'react-redux';
import {
    default as PM,
    PERMISSION_DRIVE_ACCESS,
    PERMISSION_FFDA_DASHBOARD,
    PERMISSION_DRIVE_UPLOAD,
    PERMISSION_FFDA_SUPPLIES,
    PERMISSION_FFDA_REPORTS,
    PERMISSION_SMART_ENTITY_FOLDER,
} from '../../helpers/PermissionManager';

export const BrandIconURLCSS = {
    ...AppConfig.APP_MENU_ICON_PROPS,
    backgroundImage: 'url(' + AppConfig.APP_MENU_ICON_URL + ')',
};

export const DFLT_ICO_PROPS = {
    height: '30px',
    width: '30px',
    color: 'inherit',
    fill: 'inherit',
};

const AppItem = ({ href, Icon, title, active }) => (
    <NavLink to={href || `/${title}`}>
        <div className={['amn-item', active ? 'active' : ''].join(' ')}>
            <div className="amn-bg">
                {Icon ? (
                    <Icon {...DFLT_ICO_PROPS} className="amn-logo" />
                ) : null}
                <span className="amn-title">{title}</span>
            </div>
        </div>
    </NavLink>
);

const AppMenu = ({ isMenuOpen, profile, session }) => {
    const ffdaHasDriveModule =
        process.env.REACT_APP_FFDA_DRIVE_UPLOAD_MODULE === 'true';

    return (
        <section
            className={['app-menu am-left', isMenuOpen ? 'is-open' : ''].join(
                ' '
            )}
        >
            <div className="am-brand-logo" style={BrandIconURLCSS}></div>
            <nav className="am-nav">
                <div className="amn-container">
                    <AppItem
                        title={languageManager.T('MENU_HOME')}
                        href="/homepage"
                        Icon={HomeOutline}
                    />
                    {PM.isFederated(session, profile) &&
                        PM.hasPermissions(profile, [
                            PERMISSION_FFDA_DASHBOARD,
                        ]) && (
                            <AppItem
                                title={languageManager.T('MENU_FFDA_DASHBOARD')}
                                href="/ffda/dashboard"
                                Icon={StatsChart}
                            />
                        )}
                    {PM.isFederated(session, profile) &&
                        PM.hasPermissions(profile, [
                            PERMISSION_FFDA_REPORTS,
                        ]) && (
                            <AppItem
                                title={languageManager.T('MENU_FFDA_REPORT')}
                                href="/ffda/reports"
                                Icon={PieChartOutline}
                            />
                        )}
                    {(PM.isNotFederated(session, profile) ||
                        ffdaHasDriveModule) &&
                        PM.hasPermissions(profile, [PERMISSION_DRIVE_ACCESS]) &&
                        !PM.hasEntityFolderAccess(session) && (
                            <AppItem
                                title={languageManager.T('MENU_DOCUMENTS')}
                                href="/documents/explorer"
                                Icon={CloudOutline}
                            />
                        )}

                    {(PM.isNotFederated(session, profile) ||
                        ffdaHasDriveModule) &&
                        PM.hasPermissions(profile, [PERMISSION_DRIVE_UPLOAD]) &&
                        !PM.hasEntityFolderAccess(session) && (
                            <AppItem
                                title={languageManager.T(
                                    'MENU_DOCUMENTS_UPLOAD'
                                )}
                                href="/documents/upload-center"
                                Icon={CloudUploadOutline}
                            />
                        )}
                    {PM.hasEntityFolderAccess(session) && (
                        <AppItem
                            title={languageManager.T('MENU_ENTITY_FOLDER')}
                            href="/entity/explorer"
                            Icon={FolderOutline}
                        />
                    )}
                    {PM.isFederated(session, profile) &&
                        PM.hasPermissions(profile, [
                            PERMISSION_FFDA_SUPPLIES,
                        ]) && (
                            <AppItem
                                title={'Supplies'}
                                href={'/ffda/supplies'}
                                Icon={LogoDropbox}
                            />
                        )}
                    {/**
                    {PM.isNotFederatedBusinessOwner(session, profile) && 
                        <AppItem title={languageManager.T('MENU_BILLING')} href="/settings/billing" Icon={WalletOutline} />
                    }
                    **/}
                </div>
                <div className="amn-container justify-content-end">
                    <AppItem
                        title={languageManager.T('MENU_SETTINGS')}
                        href="/settings"
                        Icon={SettingsOutline}
                    />
                </div>
            </nav>
        </section>
    );
};

const mapStateToProps = (appState) => ({
    profile: appState.userProfile,
    session: appState.session,
});

export default connect(mapStateToProps)(AppMenu);
